module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-top-backplates.6986255c.png";